// extracted by mini-css-extract-plugin
export default {"dialogContent":"ModelFormDialog_dialogContent__Z6e2I"};